import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../Components/Utility/Loader/Loader';
import * as todoAction from './store/Suggestion.action';
import { hideImage, pageSize, shortenStringWithTooltip, showBigImage } from '../../../../Components/helper';
import noImage from '../../../../assets/images/no-image.png';
import SuggestionExpandView from './ExpandViews/SuggestionExpandView';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';

function List({ loading, getSelectedCount }) {
  const { t } = useTranslation('common');

  const [state, setState] = useState({
    stateSuggestionTodoList: [],
    deleteId: null,
    hasMore: true,
    selectedIdsArray: [],
    isSelectAll: false,
    openCloseTrackingModal: false,
    sampleEditData: null,
  });
  const [isExpanded, setIsExpanded] = React.useState({
    expanded: false,
    index: null,
  });
  const careLabel = 'care-label';
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);
  const {
    SuggestionTodoListData: {
      suggestionListData,
      suggestionFilterValues: { sortOrder, sortPropertyName, searchText },
    },
    SystemMastersDetails: { subBrandAccess },
  } = useSelector((reduxState) => reduxState);

  const dispatch = useDispatch();

  const { stateSuggestionTodoList, selectedIdsArray, isSelectAll } = state;

  const handleSelection = (id) => {
    let selectIds = [...selectedIdsArray];
    if (typeof id === 'boolean') {
      setState((prevState) => ({
        ...prevState,
        isSelectAll: id,
      }));
      if (!id) selectIds = [];
      else selectIds = stateSuggestionTodoList.map((ele) => ele._id);
    } else if (id) {
      const itemIndex = selectIds.findIndex((val) => val === id);
      if (itemIndex >= 0) selectIds.splice(itemIndex, 1);
      else selectIds.push(id);
      if (selectIds.length !== stateSuggestionTodoList.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: false,
        }));
      } else if (selectIds.length === stateSuggestionTodoList.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: true,
        }));
      }
    }
    setState((prevState) => ({
      ...prevState,
      selectedIdsArray: selectIds,
    }));
    dispatch(todoAction.setSuggestionSelectedIds(selectIds));
  };
  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      await dispatch(systemMasterAction.getSubBrandAccess());
    };
    fetchSubBrandAccess();
  }, [dispatch]);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(suggestionListData)) {
      setState((prevState) => ({
        ...prevState,
        stateSuggestionTodoList: suggestionListData,
      }));
    }
  }, [suggestionListData]);
  useEffect(() => {
    getSelectedCount(selectedIdsArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIdsArray]);

  const onSortColumn = async (propertyName) => {
    if (sortOrder === '' || sortOrder === 'Desc') {
      const sortObj = {
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
        searchText,
        pageIndex: 1,
        pageSize,
        type: 'suggestion',
      };
      const obj = {
        sortOrder: 'Asc',
        sortPropertyName: propertyName,
      };
      await dispatch(todoAction.filterSortData(obj));
      await dispatch(todoAction.getSuggestionList(sortObj));
    } else {
      const sortObj = {
        sortOrder: 'Desc',
        sortPropertyName: propertyName,
        searchText,
        pageIndex: 1,
        pageSize,
        type: 'suggestion',
      };
      await dispatch(todoAction.getSuggestionList(sortObj));
      const obj = {
        sortOrder: 'Desc',
        sortPropertyName: propertyName,
      };
      await dispatch(todoAction.filterSortData(obj));
    }
  };

  const handleAscIcon = () => {
    return sortOrder === 'Asc' ? <i className="fa fa fa-sort-up ml-1" /> : <i className="fa fa fa-sort-desc ml-1" />;
  };

  const iconChanges = () => {
    return sortOrder === '' ? <i className="fa fa fa-sort ml-1" /> : handleAscIcon();
  };

  const headerSortingIcon = (lable, propertyName) => {
    return (
      <span className="cursor-pointer">
        {lable}
        {sortPropertyName === propertyName ? iconChanges() : <i className="fa fa fa-sort ml-1" />}
      </span>
    );
  };

  const toggleExpanfView = (index, section, direction) => {
    let lib = [];
    if (section === 'bom') lib = stateSuggestionTodoList[index].bomComponents;
    if (section === 'testing') lib = stateSuggestionTodoList[index].testLibraries;
    if (section === 'measurement') {
      lib = stateSuggestionTodoList[index].measurementLibaries[0];
    }
    if (section === careLabel) lib = stateSuggestionTodoList[index].careLableLibaries[0];

    setIsExpanded((prev) => ({
      ...prev,
      [`row_expanded_${index}`]: !isExpanded[`row_expanded_${index}`],
      [`row_${index}`]: direction === 'up' ? index : null,
      [`section_${index}`]: section,
      [`expandedLibData_${index}`]: lib,
    }));

    const cloneSuggestionTodoList = stateSuggestionTodoList;
    cloneSuggestionTodoList[index].isExpanded = !cloneSuggestionTodoList[index].isExpanded;
    setState((prevState) => ({
      ...prevState,
      stateSuggestionTodoList: cloneSuggestionTodoList,
      currentSection: section,
    }));
  };

  const showStatus = (x) => {
    if (x?.status === 'Approved') {
      return (
        <>
          <span>{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.APPROVED')}</span>
          <span className="col-status right approved" />
        </>
      );
    }

    if (x?.status === 'Rejected') {
      return (
        <>
          <span>{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.REJECTED')}</span>
          <span className="col-status right rejected" />
        </>
      );
    }

    if (x?.status === 'Pending' || x?.status === 'pending') {
      return (
        <>
          <span>{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.PENDING')}</span>
          <span className="col-status right pending" />
        </>
      );
    }

    if (x?.status === 'Deleted') {
      return <span>{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.DELETED')}</span>;
    }
  };

  const showMeasurementExpandIcon = (data, index) => {
    const { pomLibraries, specPomLibraries } = data.measurementLibaries[0];
    let isShow = false;
    if (pomLibraries?.length > 0 && specPomLibraries?.length > 0) {
      isShow = true;
    }
    if (pomLibraries?.length > 1 || specPomLibraries?.length > 1) {
      isShow = true;
    }

    setIsExpanded((prev) => ({
      ...prev,
      [`show_expand_icon_${index}`]: isShow,
    }));
  };

  const showCareLableExpandIcon = (data, index) => {
    if (data?.careLableLibaries?.[0]) {
      let uniqueRowIds = [];
      let isShow = false;
      const libcount = data.careLableLibaries[0]?.tabs
        ?.map((ele) => {
          if (ele?.tabDetails?.length > 0) {
            uniqueRowIds = [...new Set(ele?.tabDetails?.map((prop) => prop?.rowId))];
            return uniqueRowIds?.length;
          }
        })
        .filter(Boolean);
      const totalLib = libcount;
      if (totalLib?.length > 1) {
        isShow = true;
      }

      setIsExpanded((prev) => ({
        ...prev,
        [`show_expand_icon_${index}`]: isShow,
      }));
    }
  };

  const showExpandIcon = async (data, index) => {
    if (data) {
      if (data.section === 'bom' && data.bomComponents.length > 1) {
        setIsExpanded((prev) => ({
          ...prev,
          [`show_expand_icon_${index}`]: true,
        }));
      }
      if (data.section === 'measurement') {
        showMeasurementExpandIcon(data, index);
      }
      if (data.section === careLabel) {
        showCareLableExpandIcon(data, index);
      }
      if (data.section === 'testing' && data.testLibraries.length > 1) {
        setIsExpanded((prev) => ({
          ...prev,
          [`show_expand_icon_${index}`]: true,
        }));
      }
    }
  };

  const showType = (item, i) => {
    const type = item?.type?.charAt(0).toUpperCase() + item?.type?.slice(1);
    if (item.section === 'bom') {
      if (item.bomComponents.length > 1 && !isExpanded?.[`row_expanded_${i}`]) {
        return <div>{`BOM ${type} Multiple  ( + ${item.bomComponents.length - 1})`}</div>;
      }
      return (
        <div>
          {` ${type} ( BOM )`}
          <div>{` ${item.bomComponents[0]?.referenceCode} `}</div>
        </div>
      );
    }
    if (item.section === 'measurement') {
      const totalPomLib = item.measurementLibaries[0].pomLibraries.length;
      const totalSpecPomlib = item.measurementLibaries[0].specPomLibraries.length;
      const totalLib = totalPomLib + totalSpecPomlib;

      if (totalLib > 1 && !isExpanded?.[`row_expanded_${i}`]) {
        return <div>{`Measurement ${type} Multiple  ( + ${totalLib - 1})`}</div>;
      }
      if (item?.measurementLibaries?.[0]) {
        const { pomLibraries, specPomLibraries } = item?.measurementLibaries?.[0] ?? {};

        if ((pomLibraries.length > 0 && specPomLibraries.length > 0) || (pomLibraries.length > 0 && specPomLibraries.length === 0)) {
          return (
            <div>
              <div>{` ${pomLibraries[0]?.code} ( CAD Specification ) `}</div>
              <div>{`${type} Measurement`}</div>
            </div>
          );
        }

        if (pomLibraries.length === 0 && specPomLibraries.length > 0) {
          return (
            <div>
              <div>{` ${specPomLibraries[0]?.code} ( Others Specification ) `}</div>
              <div>{`${type} Measurement`}</div>
            </div>
          );
        }
        return <div>{` ${type} Measurement`}</div>;
      }
    } else if (item.section === careLabel) {
      let uniqueRowIds = [];
      const libcount = item.careLableLibaries[0]?.tabs
        ?.map((ele) => {
          if (ele?.tabDetails?.length > 0) {
            uniqueRowIds = [...new Set(ele?.tabDetails?.map((prop) => prop?.rowId))];
            return uniqueRowIds?.length;
          }
        })
        .filter(Boolean);
      const totalLib = libcount;
      if (totalLib.length > 1 && !isExpanded?.[`row_expanded_${i}`]) {
        return <span>{`Care Label ${type} Multiple  ( + ${totalLib?.length - 1})`}</span>;
      }
      if (item?.careLableLibaries[0]) {
        const tabCodes = [];
        item.careLableLibaries[0].tabs.map((tab) => {
          const codeColumn = tab?.tabColumns?.find((column) => column?.name === 'Code');
          if (codeColumn) {
            tab?.tabDetails?.map((detail) => {
              if (detail?.columnId === codeColumn?._id) {
                tabCodes.push(detail?.value);
              }
            });
          }
        });
        return (
          <>
            <div>{`${type} ( Care-label)`}</div>
            <span>{`${tabCodes[0]}( Disclaimers )`}</span>
          </>
        );
      }
    } else if (item.section === 'testing') {
      if (item.testLibraries.length > 1 && !isExpanded?.[`row_expanded_${i}`]) {
        return <div>{`Testing ${type} Multiple  ( + ${item.testLibraries.length - 1})`}</div>;
      }
      return (
        <div>
          {` ${type} ( Testing )`}
          <div>{` ${item.testLibraries[0]?.code} `}</div>
        </div>
      );
    }
  };

  useEffect(() => {
    if (stateSuggestionTodoList?.length) {
      stateSuggestionTodoList.forEach((item, i) => {
        showExpandIcon(item, i);
      });
    }
  }, [stateSuggestionTodoList]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePendingOrMultiple = (totalLibApproved, totalLibRejected, totalLibrary) => {
    return totalLibApproved === 0 && totalLibRejected === 0 ? (
      <>
        <span>Pending</span>
        <span className="col-status right pending" />
      </>
    ) : (
      <>
        <span>Multiple (+{totalLibrary - 1})</span>
        <span className="col-status right multiple" />
      </>
    );
  };

  const handleDeletedCount = (totalLibrary, totalLibDeleted, totalLibApproved, totalLibRejected) => {
    return totalLibrary === totalLibDeleted ? <span>Deleted</span> : handlePendingOrMultiple(totalLibApproved, totalLibRejected, totalLibrary);
  };
  const handleRejectedCount = (totalLibrary, totalLibRejected, totalLibApproved, totalLibDeleted) => {
    return totalLibrary === totalLibRejected ? (
      <>
        <span>Rejected</span>
        <span className="col-status right rejected" />
      </>
    ) : (
      handleDeletedCount(totalLibrary, totalLibDeleted, totalLibApproved, totalLibRejected)
    );
  };

  const showBOMStatus = (dataStatus, index) => {
    if (!isExpanded[`row_expanded_${index}`]) {
      const totalLibrary = parseInt(dataStatus?.length, 10) || 0;
      const totalLibApproved = parseInt(dataStatus.filter((x) => x.status === 'Approved').length, 10) || 0;
      const totalLibRejected = parseInt(dataStatus.filter((x) => x.status === 'Rejected').length, 10) || 0;
      const totalLibDeleted = parseInt(dataStatus.filter((x) => x.status === 'Deleted').length, 10) || 0;

      return totalLibrary === totalLibApproved ? (
        <>
          <span>Approved</span>
          <span className="col-status right approved" />
        </>
      ) : (
        handleRejectedCount(totalLibrary, totalLibRejected, totalLibApproved, totalLibDeleted)
      );
    }
    return showStatus(dataStatus[0]);
  };

  const showTestingStatus = (dataStatus, index) => {
    if (!isExpanded[`row_expanded_${index}`]) {
      const totalLibrary = parseInt(dataStatus?.length, 10) || 0;
      const totalLibApproved = parseInt(dataStatus.filter((x) => x.status === 'Approved').length, 10) || 0;
      const totalLibRejected = parseInt(dataStatus.filter((x) => x.status === 'Rejected').length, 10) || 0;
      const totalLibDeleted = parseInt(dataStatus.filter((x) => x.status === 'Deleted').length, 10) || 0;
      return totalLibrary === totalLibApproved ? (
        <>
          <span>Approved</span>
          <span className="col-status right approved" />
        </>
      ) : (
        handleRejectedCount(totalLibrary, totalLibRejected, totalLibApproved, totalLibDeleted)
      );
    }
    showStatus(dataStatus[0]);
  };

  const showMeasurementStatus = (dataStatus, index) => {
    if (!isExpanded[`row_expanded_${index}`]) {
      let totalLibrary;
      let totalLibApproved;
      let totalLibRejected;
      let totalLibDeleted = 0;
      dataStatus?.filter((measurementItem) => {
        totalLibrary = parseInt(measurementItem?.pomLibraries?.length, 10) + parseInt(measurementItem?.specPomLibraries?.length, 10);
        totalLibApproved =
          parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Approved').length, 10) +
          parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Approved').length, 10);

        totalLibRejected =
          parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Rejected').length, 10) +
          parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Rejected').length, 10);

        totalLibDeleted =
          parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Deleted').length, 10) +
          parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Deleted').length, 10);
      });
      return totalLibrary === totalLibApproved ? (
        <>
          <span>Approved</span>
          <span className="col-status right approved" />
        </>
      ) : (
        handleRejectedCount(totalLibrary, totalLibRejected, totalLibApproved, totalLibDeleted)
      );
    }
    const { pomLibraries, specPomLibraries } = dataStatus[0];
    if (pomLibraries.length > 0 && specPomLibraries.length > 0) {
      return showStatus(pomLibraries[0]);
    }
    if (pomLibraries.length > 0 && specPomLibraries.length === 0) {
      return showStatus(pomLibraries[0]);
    }
    if (pomLibraries.length === 0 && specPomLibraries.length > 0) {
      return showStatus(specPomLibraries[0]);
    }
  };
  const getStatusCount = (tabs, Status) => {
    // Create a Set to store unique rowIds that have pending status
    const uniqueRowIdsWithPending = new Set();

    // Iterate through each tab
    tabs?.forEach((tab) => {
      // Check if tab has tabDetails
      if (tab?.tabDetails?.length > 0) {
        // Iterate through tabDetails
        tab?.tabDetails?.forEach((detail) => {
          // Check if status is pending and add rowId to Set if true
          if (detail?.status === Status && detail?.rowId) {
            uniqueRowIdsWithPending.add(detail.rowId);
          }
        });
      }
    });

    // Return the size of the Set (number of unique rowIds with pending status)
    return uniqueRowIdsWithPending.size;
  };

  const showCareLabelStatus = (dataStatus, index) => {
    if (!isExpanded[`row_expanded_${index}`]) {
      let totalLibrary;
      let totalLibApproved;
      let totalLibRejected;
      let totalLibDeleted = 0;
      dataStatus?.filter((careLibItem) => {
        let uniqueRowIds = [];
        const libcount = careLibItem?.tabs
          ?.map((ele) => {
            if (ele?.tabDetails?.length > 0) {
              uniqueRowIds = [...new Set(ele?.tabDetails?.map((prop) => prop?.rowId))];
              return uniqueRowIds?.length;
            }
          })
          .filter(Boolean);
        totalLibrary = parseInt(libcount?.length);
        totalLibApproved = getStatusCount(careLibItem?.tabs, 'Approved');
        totalLibRejected = getStatusCount(careLibItem?.tabs, 'Rejected');
        totalLibDeleted = getStatusCount(careLibItem?.tabs, 'Deleted');
      });
      return totalLibrary === totalLibApproved ? (
        <>
          <span>Approved</span>
          <span className="col-status right approved" />
        </>
      ) : (
        handleRejectedCount(totalLibrary, totalLibRejected, totalLibApproved, totalLibDeleted)
      );
    }
    const { disclaimerLibraries, instructionLibraries, symbolLibraries } = dataStatus[0];

    if (disclaimerLibraries.length > 0 && symbolLibraries.length > 0 && instructionLibraries.length > 0) {
      return showStatus(disclaimerLibraries[0]);
    }
    if (disclaimerLibraries.length > 0 && symbolLibraries.length === 0 && instructionLibraries.length === 0) {
      return showStatus(disclaimerLibraries[0]);
    }
    if (disclaimerLibraries.length === 0 && symbolLibraries.length > 0 && instructionLibraries.length === 0) {
      return showStatus(symbolLibraries[0]);
    }
    return showStatus(instructionLibraries[0]);
  };

  const showImage = (image) => {
    if (image?.includes('https:/')) {
      return image;
    }
    return noImage;
  };

  return (
    <table className="table custom-table layout-fixed font-13 text-center customTable todo-fixed-col-table fixed-col-table-suggestion">
      <thead>
        <tr>
          <th aria-label="check" className="w-80px w-xs-40px">
            <div className="checkbox-label no-label margin-auto">
              <input
                type="checkbox"
                onChange={(e) => handleSelection(e.target.checked)}
                name="check_all_samples"
                id="check_all_samples"
                checked={isSelectAll}
                disabled={!stateSuggestionTodoList.length}
              />
              <label htmlFor="check_all_samples" className="chklabel">
                <span />
              </label>
            </div>
          </th>
          <th aria-label="check" className="w-80px w-xs-40px" />
          <th aria-label="check" className="w-80px" />

          <th className="w-150px last-fix-col" onClick={() => onSortColumn('number')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.PRODUCT_REF'), 'number')}
          </th>

          <th className="w-250px" onClick={() => onSortColumn('description')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.PRODUCT_DISCRIPTION'), 'description')}
          </th>
          <th className="w-150px" onClick={() => onSortColumn('supplier')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.SUPPLIER'), 'supplier')}
          </th>
          <th className="w-150px" onClick={() => onSortColumn('brandId')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.BRAND'), 'brand')}
          </th>
          {subBrandAccess && (
            <th className="w-150px" onClick={() => onSortColumn('subBrand')}>
              {t('TABLE_HEADERS_LIST.SUB_BRAND')}
            </th>
          )}
          <th className="w-150px" onClick={() => onSortColumn('seasonId')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.SEASON'), 'seasonId')}
          </th>

          <th className="w-150px" onClick={() => onSortColumn('month')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.MONTH'), 'month')}
          </th>

          <th className="w-150px" onClick={() => onSortColumn('year')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.YEAR'), 'year')}
          </th>
          {catBasedOnPTData && (
            <th className="w-150px" onClick={() => onSortColumn('productType')}>
              {headerSortingIcon(t('TABLE_HEADERS_LIST.PRODUCT_TYPE'), t('TABLE_HEADERS_LIST.PRODUCT_TYPE_ID'))}
            </th>
          )}
          <th className="w-150px" onClick={() => onSortColumn('catOneId')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.CATEGORY_1'), 'catOneId')}
          </th>

          <th className="w-150px" onClick={() => onSortColumn('catTwoId')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.CATEGORY_2'), 'catTwoId')}
          </th>

          <th className="w-150px" onClick={() => onSortColumn('catThreeId')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.CATEGORY_3'), 'catThreeId')}
          </th>

          <th className="w-150px" onClick={() => onSortColumn('catFourId')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.CATEGORY_4'), 'catFourId')}
          </th>

          <th className="w-150px" onClick={() => onSortColumn('type')}>
            {headerSortingIcon(t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.TYPE'), 'type')}
          </th>

          <th className="w-120px">{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.STATUS')}</th>

          <th className="w-80px">{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.ACTION')}</th>
        </tr>
      </thead>
      <tbody>
        {stateSuggestionTodoList.length > 0 &&
          stateSuggestionTodoList.map((item, i) => {
            return (
              <>
                <tr key={item?._id}>
                  <td aria-label="check">
                    <div className="checkbox-label no-label margin-auto">
                      <input
                        onChange={() => {
                          handleSelection(item?._id);
                        }}
                        name={`checks_${i}`}
                        id={`checks_${i}`}
                        type="checkbox"
                        checked={selectedIdsArray.filter((val) => val === item?._id).length > 0}
                      />
                      <label htmlFor={`checks_${i}`} className="chklabel">
                        <span />
                      </label>
                    </div>
                  </td>
                  <td>
                    {isExpanded[`show_expand_icon_${i}`] &&
                      (item.isExpanded ? (
                        <button
                          className="btn-up-down"
                          onClick={() => {
                            toggleExpanfView(i, item.section, 'down');
                          }}
                          type="button"
                          aria-label="Expand"
                        >
                          <span className="icon-new-down-arrow-icon icon-inverse" />
                        </button>
                      ) : (
                        <button
                          className="btn-up-down"
                          onClick={() => {
                            toggleExpanfView(i, item.section, 'up');
                          }}
                          type="button"
                          aria-label="expand"
                        >
                          <span className="icon-new-down-arrow-icon" />
                        </button>
                      ))}
                  </td>
                  <td>
                    <div className="image-detail hover-right">
                      <figure onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
                        <div className="img-preview-inside-table sm">
                          <img width="60" alt="product img" src={showImage(item.image)} />
                        </div>
                      </figure>
                    </div>
                  </td>

                  <td className="last-fix-col">{item?.number || '--'}</td>
                  <td>{item?.description ? shortenStringWithTooltip(item.description, 60) : '--'}</td>
                  <td>{item?.supplierId || '--'}</td>
                  <td>{item?.brandId || '--'}</td>
                  {subBrandAccess && <td>{item?.subBrandId || '--'}</td>}
                  <td>{item?.seasonId || '--'}</td>
                  <td>{item?.month || '--'}</td>
                  <td>{item?.year || '--'}</td>
                  {catBasedOnPTData && <td>{item?.supplierType || '--'}</td>}
                  <td>{item?.catOneId || '--'}</td>
                  <td>{item?.catTwoId || '--'}</td>
                  <td>{item?.catThreeId || '--'}</td>
                  <td>{item?.catFourId || '--'}</td>

                  <td>
                    <div>{showType(item, i)}</div>
                  </td>

                  <td className="text-capitalize position-relative">
                    {item.section === 'bom' && showBOMStatus(item.bomComponents, i)}
                    {item.section === 'testing' && showTestingStatus(item.testLibraries)}
                    {item.section === 'measurement' && showMeasurementStatus(item.measurementLibaries, i)}
                    {item.section === careLabel && showCareLabelStatus(item.careLableLibaries, i)}
                  </td>

                  <td>
                    <div className="d-flex align-items-center">
                      <Link
                        className="cursor-pointer text-dark text-decoration-none btn"
                        to={`/supplier-suggestion/detail/${item._id}/${item?.section}`}
                        title="View"
                      >
                        <i className="icon-active" />
                      </Link>

                      <div className="info-container d-flex text-left">
                        <span className="icon-info f-18" />
                        <div className="info-content">
                          <p className="mb-1">
                            <b>{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.CREATED_AT')}&nbsp;</b>
                            {moment(item.createdAt).format('DD-MM-YYYY, h:mm a')}
                          </p>
                          <p className="mb-1">
                            <b>{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.CREATED_BY')}&nbsp;</b>

                            {item.createdBy}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>

                {isExpanded?.[`row_expanded_${i}`] &&
                  isExpanded?.[`row_${i}`] === i &&
                  (isExpanded?.[`section_${i}`] === 'testing' || isExpanded?.[`section_${i}`] === 'bom') &&
                  Array.isArray(isExpanded?.[`expandedLibData_${i}`]) &&
                  isExpanded?.[`expandedLibData_${i}`].length > 1 &&
                  isExpanded?.[`expandedLibData_${i}`].map((_libData, ind) => {
                    return <SuggestionExpandView subBrandAccess={subBrandAccess} index={ind} data={item} key={`expandedLibData_${i}_item_${ind}`} />;
                  })}

                {isExpanded?.[`row_expanded_${i}`] && isExpanded?.[`row_${i}`] === i && isExpanded?.[`section_${i}`] === 'measurement' && (
                  <SuggestionExpandView subBrandAccess={subBrandAccess} data={item} />
                )}

                {isExpanded?.[`row_expanded_${i}`] && isExpanded?.[`row_${i}`] === i && isExpanded?.[`section_${i}`] === careLabel && (
                  <SuggestionExpandView subBrandAccess={subBrandAccess} data={item} />
                )}
              </>
            );
          })}
        {loading && (
          <tr>
            <td aria-label="expand" colSpan="100%">
              <Loader />
            </td>
          </tr>
        )}
        {stateSuggestionTodoList.length === 0 && !loading && (
          <tr>
            <td colSpan={13}>{t('DASHBORD.TO_DO_LIST.SUGGESTION.LIST.NO_RECORD_FOUND')}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default List;
